module.exports = __webpack_public_path__ + "img/w-regions.e77b9a08.png";